import type { PlanReviewListItem } from "@/api/plan_review";

// The browser's clock and the server's can disagree by a little; a run the
// server stamped a few seconds before the browser's submit time is still
// this submit's run.
const CLOCK_SKEW_MS = 60 * 1000;

/**
 * Finds the runs that could be the one the server created for a Start Review
 * submit whose response never reached the browser (Heroku H27: the client
 * dropped the stream after the server had already queued the run). Newest
 * first. The list payload carries no file name, so the caller checks that
 * against each full run after fetching it and takes the first that matches.
 *
 * Status is deliberately not a filter: a run this submit made that has
 * already failed is still this submit's run, and showing its failure beats
 * guessing that it "may have started".
 */
export function findReviewsStartedBy(
  reviews: PlanReviewListItem[],
  submit: { title: string; municipalityId: number; submittedAt: number }
): PlanReviewListItem[] {
  const title = submit.title.trim();
  const notBefore = submit.submittedAt - CLOCK_SKEW_MS;

  return reviews
    .filter(
      (review) =>
        review.municipality_id === submit.municipalityId &&
        review.submission_id == null &&
        review.title.trim() === title &&
        Date.parse(review.created_at) >= notBefore
    )
    .sort((a, b) => Date.parse(b.created_at) - Date.parse(a.created_at));
}
